import React from 'react';
import {useTranslation} from 'react-i18next';
import TextField from "@mui/material/TextField";
import InputAdornment from '@mui/material/InputAdornment';

const InputTextField = (props: any) => {
    const {t, i18n} = useTranslation();
    return (
      <TextField id="filled-basic" fullWidth margin="normal"
        variant="filled"
        InputProps={{
          disableUnderline: true, startAdornment: props?.icon ? (
            <InputAdornment position="start" style={{marginTop: '0px'}}>
              <img src={props?.icon as string} />
            </InputAdornment>
          ) : null, style: {border: '1px solid #E7E8EA', background: 'white', borderRadius: '40px', fontSize: '16px', height: '56px', padding: '0px 20px'},
        }}
        inputProps={{style: {padding: '0px', ...props?.customstyle}}}
        style={{marginTop: '0px', marginBottom: '0px'}}
        InputLabelProps={{
          style: {color: '#7A808A', left: (props?.icon ? '30px' : '0px')},
        }}
        {...props} />
    );
  };
  
  export default InputTextField;
